import test_entry_config from "../config/test_entry_config.json";
import { cloneDeep, sum } from "lodash";
import { getGrayScaleImageForPValue } from "../statistics_map/StatisticsMap";
import i18next from "i18next";

export function calculateGht(
  testType,
  eye,
  psdProbabilities,
  gh,
  meanDeviation,
  fpVal,
  vfi,
  percentagesStr,
) {
  const config = cloneDeep(test_entry_config);
  const ghtZones = config["ghtZones"][testType][eye];
  const statistics = config["statisticsValueBorders"][percentagesStr];
  const ghtTable = [];
  const zone2 = ["top", "down"];
  let eyeIndex = 0;
  for (let i = 0; i < 5; i++) {
    const zones = ghtZones[i + 1];
    console.log(zones, eyeIndex);
    const s = calculateGhtZoneSum(zones[zone2[eyeIndex]]);
    eyeIndex = (eyeIndex + 1) % 2;
    const s2 = calculateGhtZoneSum(zones[zone2[eyeIndex]]);
    eyeIndex = (eyeIndex + 1) % 2;
    ghtTable.push([s, s2, zones[zone2[eyeIndex]].length]);
    console.log(s, s2);
  }

  const grayScaleCounts = { 0: 0, 3: 0, 4: 0, 6: 0, 8: 0 };
  psdProbabilities.map((p) => (grayScaleCounts[getGrayScaleImageForPValue(statistics, p)] += 1));

  function calculateGhtZoneSum(zoneIndices) {
    const zoneElems = [];
    zoneIndices.forEach((i) => zoneElems.push(psdProbabilities[i]));
    return sum(zoneElems);
  }
  const diffArray = [];
  ghtTable.forEach((sums) => diffArray.push(Math.abs(Number((sums[0] - sums[1]).toPrecision(3)))));

  let coef = 1;
  if (testType === "30-2") {
    coef = 0.5;
  }

  const outsideOfNormalPLimit = statistics[0] * coef;
  const outsideOfNormalDiffLimit = 1.8 / coef;
  const borderlinePLimit = statistics[3] * coef;
  const borderlineDiffLimit = 1.5 / coef;
  const borderlineLowDiffLimit = 1 / coef;
  const ghDbEdgeValue = 3 * coef;
  const isGhAbnormallyHigh = gh >= ghDbEdgeValue;
  const isGhAbnormallyLow = gh <= -1 * ghDbEdgeValue;
  console.log(
    "ghtTable",
    ghtTable,
    diffArray,
    gh,
    ghtTable.map((sums) => [
      Math.abs(sums[0] / sums[2]),
      Math.abs(sums[1] / sums[2]),
      outsideOfNormalPLimit,
      Math.abs(sums[0] / sums[2]) < outsideOfNormalPLimit,
    ]),
  );

  if (isGhAbnormallyHigh && fpVal >= 35) {
    return i18next.t("ght.abnormallyHighSensitivity");
  } else if (
    grayScaleCounts["0"] + grayScaleCounts["3"] > 3 &&
    vfi <= 92 &&
    (diffArray.filter((d) => d > outsideOfNormalDiffLimit).length > 0 ||
      ghtTable.filter(
        (sums) =>
          Math.abs(sums[0] / sums[2]) < outsideOfNormalPLimit ||
          Math.abs(sums[1] / sums[2]) < outsideOfNormalPLimit,
      ).length > 0)
  ) {
    return i18next.t("ght.outsideNormalLimits");
  } else if (
    grayScaleCounts["0"] + grayScaleCounts["3"] + grayScaleCounts["4"] > 3 &&
    vfi <= 95 &&
    (diffArray.filter((d) => d > borderlineDiffLimit).length > 0 ||
      ghtTable.filter(
        (sums) =>
          Math.abs(sums[0] / sums[2]) < borderlinePLimit ||
          Math.abs(sums[1] / sums[2]) < borderlinePLimit,
      ).length > 0 ||
      (diffArray.filter((d) => d > borderlineLowDiffLimit).length > 0 && meanDeviation <= -1))
  ) {
    if (isGhAbnormallyLow) {
      return i18next.t("ght.generalReductionOfSensitivity");
    } else {
      return i18next.t("ght.borderline");
    }
  } else if (isGhAbnormallyLow) {
    return i18next.t("ght.generalReductionOfSensitivity");
  } else {
    return i18next.t("ght.withinNormalLimits");
  }
}
